"use client"

import { Card, Title, BigValue, Unit, Track, GradientTrack, Scale, Marker } from './primitives'
import styled from "styled-components"

const Status = styled.p`
  font-size: 0.875rem;
  color: var(--color-optimal-foreground);
  margin: 0.125rem 0 0;
`

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`

const HeaderRight = styled.div`
  text-align: right;
`

export default function DiversificationCard() {
  const score = 82
  return (
    <Card>
      <Header>
        <Title>Diversification score</Title>
        <HeaderRight>
          <BigValue>
            {score}
            <Unit>/100</Unit>
          </BigValue>
          <Status>Well balanced</Status>
        </HeaderRight>
      </Header>

      <Track>
        <GradientTrack />
        <Marker percent={score} color="var(--color-optimal)" />
      </Track>
      <Scale>
        <span>0</span>
        <span>50</span>
        <span>100</span>
      </Scale>
    </Card>
  )
}
